import { Badge, DefaultTooltip } from 'twyne-new.ui';

import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';

export default function SCAStatusFormatter({ info }) {
  const { row: winner } = getInfo(info)
  const id = keyOf(info, "sca-status")

  const { errorCode, status } = winner
  const { color, label, tip } = SCA_STATUSES[errorCode ? 'error' : status] || {}

  if (!label) {
    return '--'
  }

  return <DefaultTooltip content={tip}>
    <Badge id={id} variant='outline' color={color} size='sm'>
      {label}
    </Badge>
  </DefaultTooltip>
}

const SCA_STATUSES = {
  contest_finished: {
    color: 'danger',
    label: 'started',
    tip: 'The contest has finished and the file is being sent.',
  },
  file_delivered: {
    color: 'warning',
    label: 'delivered',
    tip: 'The file has been uploaded and receipt is being confirmed.',
  },
  file_confirmed: {
    color: 'accent',
    label: 'waiting',
    tip: 'File upload has been confirmed and the winning ticket is being drawn.',
  },
  winner_checked: {
    color: 'success',
    label: 'drawn',
    tip: 'A ticket has been drawn for the contest.',
  },
  null: {
    color: 'neutral',
    label: 'inactive',
    tip: 'No SCA Promotions integration is enabled.',
  },
  error: {
    color: 'danger',
    label: 'error',
    tip: 'Internal error. Please contact support.',
  },
}
